import { v4 as uuidv4 } from 'uuid'; // Import UUID library

// Function to generate a new API key for a user
const generateAPIKey = () => {
  // Generate a unique API key using UUID
  const newAPIKey = uuidv4(); // Example: '123e4567-e89b-12d3-a456-426614174000'
  
  //console.log("Generated API Key:", newAPIKey); // Log the generated API key (optional)

  return newAPIKey; // Return the new API key
};

export default generateAPIKey;
